import { AccountSection } from '@/components/AppSettings/internal/AccountSection'
import { AboutSection } from '@/components/AppSettings/internal/AboutSection'

export default function Account() {
    return (
        <div className="flex flex-col gap-[10px]">
            <AccountSection />
            <AboutSection />
        </div>
    )
}
